import React, { useEffect, useState } from "react";
import { dashboardAPI } from "../../Api/dashboardAPI";
import { toastError, toastInfo, toastSuccess } from "../../utils/toast";
import TableList from "../../components/TableList/TableList";
import SlRadio from "@shoelace-style/shoelace/dist/react/radio";
import Button from "../../components/reusable/Button/Button";
import PageLoader from "../../components/reusable/PageLoader/PageLoader";
import { TransaccionEnTransito } from "../../types/transaccionesEnTransito";
import Pagination from "../../components/reusable/Pagination/Pagination";
import useAuth from "../../hooks/useAuth";

function InscripcionesEnTransito() {
  const [loading, setLoading] = useState(false);
  const [InscripcionesEnTransito, setInscripcionesEnTransito] = useState<
    TransaccionEnTransito[]
  >([]);
  const [inscripcionesSeleccionadas, setInscripcionesSeleccionadas] = useState<
    number[]
  >([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalInscripciones, setTotalInscripciones] = useState(0);
  const { hasPermission } = useAuth();
  const pageLimit = 50;

  const getReservas = async (newPage?: number) => {
    setLoading(true);
    try {
      const { transacciones, totalCount } =
        await dashboardAPI.getInscripcionesEnTransito(
          pageLimit,
          newPage ? (newPage - 1) * pageLimit : 0
        );
      setInscripcionesEnTransito(transacciones);
      setTotalInscripciones(totalCount);
    } catch (error) {
      toastError();
    }
    setLoading(false);
  };

  useEffect(() => {
    getReservas();
  }, []);

  const renderRadioButton = (transaccion: TransaccionEnTransito) => {
    const checked = inscripcionesSeleccionadas.some(
      (id) => id === transaccion.id
    );
    return (
      <div className="flex w-20 justify-center">
        <SlRadio
          className="pl-2"
          value="1"
          checked={checked}
          onClick={() => {
            if (checked) {
              setInscripcionesSeleccionadas((t) =>
                t.filter((id) => id !== transaccion.id)
              );
            } else {
              setInscripcionesSeleccionadas((t) => [...t, transaccion.id]);
            }
          }}
        />
      </div>
    );
  };

  const handleDescartarInscripcionEnTransito = async (ids: number[]) => {
    if (!ids.length) return;
    try {
      setLoading(true);
      const response = await dashboardAPI.cancelarInscripcionesEnTransitoXId(
        ids
      );
      if (response.status === 200) {
        await getReservas();
      } else {
        toastError("Error al intentar cancelar inscripciones en transito");
      }
    } catch (error) {
      console.log(
        "Error al intentar cancelar inscripciones en transito",
        error
      );
    } finally {
      setLoading(false);
      setInscripcionesSeleccionadas([])
    }
  };

  return (
    <div>
      {loading && <PageLoader />}
      <div className="flex flex-col px-10 py-5">
        <div>
          <div className="flex flex-col">
            <strong className="text-base">
              Inscripciones no procesadas por Oracle
            </strong>
            <div className="flex flex-row items-center my-2 gap-2">
              <Button
                label="Cancelar inscripciones seleccionadas"
                onClick={() =>
                  handleDescartarInscripcionEnTransito(
                    inscripcionesSeleccionadas
                  )
                }
                disabled={
                  inscripcionesSeleccionadas.length === 0 ||
                  !hasPermission(
                    "transacciones_fallidas",
                    "reprocesar_transacciones"
                  )
                }
              />
              {inscripcionesSeleccionadas.length > 0 && (
                <Button
                  theme="red"
                  label="Limpiar seleccion"
                  onClick={() => setInscripcionesSeleccionadas([])}
                />
              )}
            </div>
          </div>
          {InscripcionesEnTransito.length < 1 && (
            <p>No se encontraron inscripciones pendientes a reprocesar</p>
          )}
          <TableList
            page="reservas"
            customColumns={[
              {
                columnTitle: "Reprocesar",
                boxContent: (d) => renderRadioButton(d),
              },
            ]}
            list={InscripcionesEnTransito}
          />
          <Pagination
            onPageChange={setCurrentPage}
            currentPage={currentPage}
            totalCount={totalInscripciones}
          />
        </div>
      </div>
    </div>
  );
}

export default InscripcionesEnTransito;
